module.exports = __webpack_public_path__ + "img/KingShowGames_Logo.34521b11.png";